export namespace StdObj {
    export interface Address {
        address: string;
        city: string;
        state: string;
        zipCode: string;
    }

    export interface NumericListItem {
        ID: number;
        Display: string;
        IsSelected?: boolean;
    }

    export interface ListItem {
        ID: string;
        Display: string;
        IsSelected?: boolean;
    }

    export interface DebugInfo {
        numMyHomeClicks: number;
        lastPageClick: string;
        numRouterEvents: number;
        numSetActiveModuleEvents: number;
    }

    export class PaginationInfo{
        currentPageIndex:number;
        total:number;
        pageSize: number;
        numPages: number;

        get rangeText():string{
            return `${(this.currentPageIndex * this.pageSize) + 1} - ${Math.min((this.currentPageIndex + 1) * this.pageSize, this.total)} of ${this.total}`;
        }

        get havePreviousPage():boolean{
            return this.currentPageIndex > 0;
        }

        get haveNextPage():boolean{
            return this.numPages > this.currentPageIndex +1;
        }
        get oDataSuffix():string{
            return `&skip=${this.currentPageIndex * this.pageSize}&top=${this.pageSize}`;
        }
    }
}
